import { useTranslation } from 'react-i18next'

import { formatDateTime } from '../../../utils/date'

/**
 * When the scheduled job runs next, shown in every state.
 *
 * It used to show when the job last ran. The next run is what the reader
 * acts on: it says when new data can arrive at the earliest. The backend
 * computes it (last check + sync interval), so the interval is not
 * duplicated here.
 *
 * With the scheduler stopped that time is already past, and showing it
 * would read as a promise the job is not keeping: it says the check is late
 * instead.
 *
 * Renders nothing when no run has ever happened: there is nothing to
 * schedule from.
 */
export const NextCheckLine = ({
  nextCheckAt,
  stalled = false,
}: {
  nextCheckAt?: string
  stalled?: boolean
}) => {
  const { t } = useTranslation()

  if (!nextCheckAt) return null

  return (
    <>
      <br />
      {stalled
        ? t('Check delayed')
        : t('Next check on {{ at }}', {
            at: formatDateTime(new Date(nextCheckAt)),
          })}
    </>
  )
}
